<template>
  <div>
    <el-container style="overflow: hidden; min-width: 1600px">
      <div style="float: left; width: 35%; white-space: nowrap">
        <el-form inline>
          <el-form-item label="装车单号">
            <el-input
              v-model="filters.loadCarNo"
              placeholder="请输入装车单号"
              clearable
              @change="handleSearchChange($event, 'loadCarNo')"
            ></el-input>
          </el-form-item>
          <el-form-item label="SKU">
            <el-input
              v-model="filters.sku"
              placeholder="请输入SKU"
              clearable
              @change="handleSearchChange($event, 'sku')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="float: left; width: 30%">
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>

        <!-- <el-button type="primary" @click="addBoxMark">提交</el-button> -->
      </div>
    </el-container>

    <el-container>
      <el-main>
        <div>
          <!-- left sidebar -->
          <div class="left-item">
            <el-card class="box-card" style="width: 100%">
              <div slot="header" class="clearfix">
                <span>待装车出库</span>
              </div>
              <div class="left-item-card">
                <div style="width: 99%">
                  <template v-if="shartSearch">
                    <el-card
                      class="box-card"
                      style="width: 100%; background-color: rgba(0, 0, 0, 0.1)"
                    >
                      <div
                        class="text item"
                        style="text-align: center; color: #909399"
                      >
                        <i class="el-icon-loading"></i>搜索中...
                      </div>
                    </el-card>
                  </template>
                  <template v-else>
                    <template v-if="WaitPickList.length">
                      <el-card
                        class="box-card"
                        v-for="(item, index) in WaitPickList"
                        :key="index"
                        style="
                          margin-bottom: 10px;
                          cursor: pointer;
                          width: 100%;
                        "
                        @click.native="selectCurrentDiv(item, index)"
                        :style="{
                          'background-color': WaitPickList[index].checked
                            ? '#C5C7CC'
                            : '',
                        }"
                      >
                        <div class="text item">
                          <div>装车单号:{{ item.loadCarNo }}</div>
                          <div>参考号：{{ item.referenceNo }}</div>
                          <div>
                            预计装车时间:{{ item.expectedLoadTimeDesc }}
                          </div>
                          <div>总体积:{{ item.totalVolume }}</div>
                          <div>总重量:{{ item.totalWeight }}</div>
                          <div>总箱数:{{ item.boxNum }}</div>
                        </div>
                      </el-card>
                    </template>
                    <template v-else>
                      <el-card class="box-card" style="width: 100%">
                        <div
                          class="text item"
                          style="text-align: center; color: #909399"
                        >
                          暂无数据
                        </div>
                      </el-card>
                    </template>
                  </template>
                </div>
              </div>
            </el-card>
          </div>

          <!-- right table -->
          <div
            style="float: left; margin-left: 2%; width: 78%"
            class="otherTable"
          >
            <div>
              <el-row type="flex" class="row-bg">
                <span style="color: red"> {{ scanBoxCodeErrorMsg }}</span>
              </el-row>
            </div>

            <div>
              <el-form ref="form" :inline="true" label-width="80px">
                <div class="all-status">
                  <el-form-item label="扫码装车">
                    <el-input
                      v-model.trim="filters.scanBoxCode"
                      placeholder="请扫描箱子箱唛信息"
                      clearable
                      @keyup.enter.native="getBoxCode"
                    ></el-input>
                  </el-form-item>
                </div>

                <div class="all-right">
                  <el-form-item label="出库状态">
                    <el-select
                      v-model="outboundStatusAll"
                      clearable
                      placeholder="请选择"
                      size="mini"
                    >
                      <el-option
                        v-for="item in outboundStatusItem"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="mini" @click="fill"
                      >一键填充</el-button
                    >
                  </el-form-item>
                </div>
              </el-form>
            </div>

            <div class="all-clear">
              <el-table-bar :fixed="true" :bottom="35">
                <el-table
                  border
                  :data="tableData"
                  style="width: 100%"
                  v-loading="listLoading"
                  @selection-change="handleRowSelect"
                  @row-click="handleRowClick"
                  ref="multipleTable"
                >
                  <el-table-column type="selection" width="50" align="center">
                  </el-table-column>
                  <el-table-column
                    prop="containerNo"
                    label="货柜号"
                    min-width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="destinationBoxNo"
                    label="箱唛"
                    min-width="100"
                  >
                  </el-table-column>
                  <el-table-column prop="boxNo" label="箱号" min-width="50">
                  </el-table-column>
                  <el-table-column prop="volume" label="箱规" min-width="50">
                    <template slot-scope="scope">
                      <span>{{
                        `${scope.row.boxLength}*${scope.row.boxWidth}*${scope.row.boxHeight}`
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="boxWeight"
                    label="重量(kg)"
                    min-width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="volume"
                    label="体积(cbm)"
                    min-width="50"
                  >
                  </el-table-column>
                  <el-table-column prop="code" label="客户代码" min-width="100">
                  </el-table-column>
                  <el-table-column
                    prop="deliveryStatus"
                    label="出库状态"
                    min-width="100"
                  >
                    <template slot-scope="scope">
                      <!-- @change="entranceChange(scope.row, scope.$index)" -->
                      <el-select
                        v-model="scope.row.deliveryStatus"
                        clearable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in outboundStatusItem"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </el-table-bar>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>

    <!--  -->
    <el-dialog
      title="维护装车司机信息"
      :visible.sync="editPutCarDriverInfoVisible"
      v-model="editPutCarDriverInfoVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="editPutCarDriverInfoForm"
        :rules="addFormRules"
        ref="editPutCarDriverInfoForm"
        label-width="80px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="车牌："
              prop="carNumber"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editPutCarDriverInfoForm.carNumber"
                auto-complete="off"
                placeholder="请输入车牌"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="司机："
              prop="driver"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editPutCarDriverInfoForm.driver"
                auto-complete="off"
                placeholder="请输入司机姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
              label="电话："
              prop="driverPhone"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editPutCarDriverInfoForm.driverPhone"
                auto-complete="off"
                placeholder="请输入电话"
                type="tel"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="editPutCarDriverInfoVisible = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="editPutCarDriverInfoSubmit"
            :loading="editLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      title="完成装车"
      :visible.sync="showPhotoModel"
      @close="close"
      :center="true"
      width="40%"
    >
      <div style="font-size: 15px; font-weight: 600; margin-bottom: 10px">
        出库{{ num1s || 0 }}箱，未出库{{ num2s || 0 }}箱。
      </div>
      <div class="demo-image" style="height: 500px">
        <ul v-for="(item, i) in photoList" :key="i">
          <div v-for="(item2, i2) in item" :key="i2" class="image-box">
            <p>
              <span style="color: red" v-if="item2.required">*</span
              >{{ item2.text }}
            </p>
            <div
              class="sign-photo-item"
              v-if="imgObj[item2.name]"
              @mouseover="imgMouseOver(i, i2)"
              @mouseleave="imgMouseLeave(i, i2)"
            >
              <div class="del-box" v-if="item2.showControl">
                <i
                  class="el-icon-zoom-in"
                  style="margin-right: 10px"
                  @click="showImg(imgObj[item2.name])"
                ></i>
                <i class="el-icon-delete" @click="deleteImg(item2.name)"></i>
              </div>
              <div class="loading-box" v-if="item2.loading">
                <i class="el-icon-loading"></i>
              </div>
              <img
                :src="imgObj[item2.name]"
                class="sign-photo-item-img"
                alt=""
              />
            </div>

            <div class="sign-photo-btn" v-else>
              <div class="photo">
                <input
                  class="img hidden"
                  @change="changeImg(i, i2)"
                  type="file"
                  name="cover"
                  ref="inputer"
                  accept="image/*"
                />
                <p @click="chooseImage(item2.id)" class="photo-s">
                  <i class="el-icon-picture-outline"></i>
                </p>
              </div>
            </div>
          </div>
        </ul>

        <el-dialog :visible.sync="dialogVisible" :modal="false">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit" v-if="IshowFinshPutCarBtn"
          >确认装车</el-button
        >
        <el-button @click="close">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetWaitPutOnCarList,
  GetWaitPutOnCarBoxList,
  PutOnCarSubmit,
  ScanCodeDeliveryBox,
  GetPutCarDriverInfo,
  SavePutCarDriverInfo,
  GetPutOnCarLoadingReviewImageListType,
} from "@/api/outbound/LoadingForPC.js";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { BaseApiUrl } from "@/api/axios_config";
import axios from "axios";
import { splitStr } from "/util/util";

export default {
  components: { Toolbar },
  data() {
    return {
      flag: false,
      filters: {},
      buttonList: [],
      listLoading: false,
      tableData: [],
      Deliverydata: [],
      editLoading: false,
      total: 0,
      validation: true,
      WaitPickList: [],
      scanBoxCodeErrorMsg: "",
      editPutCarDriverInfoVisible: false,
      editPutCarDriverInfoForm: {},
      outboundStatusItem: [
        {
          value: "1",
          label: "已出库",
        },
        {
          value: "2",
          label: "未出库",
        },
      ],
      outboundStatusAll: "",

      showPhotoModel: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,

      selectRows: [],
      curTransportType: "",

      currentImg: "",
      imgObj: {
        // 图片类型 1.车牌照 2.空柜照 3.托运单 4.未关门照 5.半关门照 6关门照 7.锁封照 8.其他 9.其他1
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      },
      photoList: [
        [
          {
            name: "img1",
            text: "车牌照",
            id: 1,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img2",
            text: "空柜照",
            id: 2,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img3",
            text: "托运单",
            id: 3,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
        [
          {
            name: "img4",
            text: "未关门照",
            id: 4,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img5",
            text: "半关门照",
            id: 5,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img6",
            text: "关门照",
            id: 6,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
        [
          {
            name: "img7",
            text: "锁封照",
            id: 7,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img8",
            text: "其他",
            id: 8,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img9",
            text: "其他1",
            id: 9,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
      ],
      imgFiles: [],
      saveImgUrlArr: [],
      IshowFinshPutCarBtn: false,
      num1s: 0,
      num2s: 0,
      shartSearch: false,
      addFormRules: {
        carNumber: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
          { min: 1, max: 20, message: "最多20个字符", trigger: "blur" },
        ],
        driver: [
          { required: true, message: "请输入司机信息", trigger: "blur" },
          { min: 1, max: 100, message: "最多100个字符", trigger: "blur" },
        ],
        driverPhone: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { min: 1, max: 11, message: "最多11个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    callFunction(item) {
      this[item.func].apply(this, item);
    },

    initTable() {
      this.shartSearch = true;
      GetWaitPutOnCarList(this.filters).then((res) => {
        this.shartSearch = false;
        var result = res.data.response;
        if (result.length > 0) {
          this.WaitPickList = res.data.response;
          this.WaitPickList[0].checked = true;
          this.curTransportType = this.WaitPickList[0].transportType;
          this.QuerySkustock(this.WaitPickList[0]);
        } else {
          this.WaitPickList = [];
          this.tableData = [];
        }
      });
    },
    getBoxCode() {
      const that = this;
      let loadCarInfoID = "";
      that.WaitPickList.forEach((item, i) => {
        if (item.checked) loadCarInfoID = item.loadCarInfoID;
      });
      if (!that.filters.scanBoxCode) return;
      ScanCodeDeliveryBox({
        scanCode: that.filters.scanBoxCode,
        loadCarInfoID: loadCarInfoID,
      }).then((res) => {
        if (res.status === 200) {
          //  this.getDetail()

          that.RefreshscanBoxData(that.filters.scanBoxCode);
          that.scanBoxCodeErrorMsg = `【${that.filters.scanBoxCode}】成功!`;
          that.filters.scanBoxCode = "";
        } else {
          that.scanBoxCodeErrorMsg = `失败:【${that.filters.scanBoxCode}】${res.msg}`;
          that.filters.scanBoxCode = "";
        }
      });
    },
    RefreshscanBoxData(scanBoxCode) {
      const that = this;
      console.log("是否刷新了页面");
      that.tableData.forEach((item2, i2) => {
        console.log(scanBoxCode + "----" + item2.destinationBoxNo);
        if (
          scanBoxCode === item2.destinationBoxNo ||
          scanBoxCode === item2.logisticsBoxNo ||
          scanBoxCode === item2.wmsBoxNo
        ) {
          console.log("是否进来了");
          that.$set(this.tableData[i2], "deliveryStatus", "1");
        }
      });
    },
    editPutCarDriverInfo() {
      this.editPutCarDriverInfoForm = {};
      let loadCarInfoID = "";
      this.WaitPickList.forEach((item, i) => {
        if (item.checked) loadCarInfoID = item.loadCarInfoID;
      });

      if (!loadCarInfoID) {
        this.$message({
          message: "请点击一条装车数据",
          type: "error",
        });
        return;
      }
      this.editPutCarDriverInfoVisible = true;

      GetPutCarDriverInfo({ loadCarInfoID: loadCarInfoID }).then((res) => {
        this.editPutCarDriverInfoForm = res.response;
      });
    },
    editPutCarDriverInfoSubmit() {
      const that = this;

      this.$refs.editPutCarDriverInfoForm.validate((valid) => {
        if (valid) {
          let regcarNumber =
            /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/;
          if (!regcarNumber.test(that.editPutCarDriverInfoForm.carNumber)) {
            this.$message({
              message: "请输入正确的车牌号",
              type: "error",
            });
            return false;
          }

          let regdriverPhone =
            /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(14[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
          if (!regdriverPhone.test(that.editPutCarDriverInfoForm.driverPhone)) {
            this.$message({
              message: "请输入正确的电话号码",
              type: "error",
            });
            return false;
          }

          const loading = this.$loading({
            lock: true,
            text: "请稍等...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.5)",
          });
          SavePutCarDriverInfo(this.editPutCarDriverInfoForm).then((res) => {
            loading.close();
            if (res.status === 200 && res.success) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.editPutCarDriverInfoVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    QuerySkustock(item) {
      this.tableData = [];
      var para = {
        loadCarInfoID: item.loadCarInfoID,
      };
      const loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      GetWaitPutOnCarBoxList(para).then((res) => {
        loading.close();
        this.tableData = res.data.response;
        this.total = this.tableData.length;
      });
    },

    selectCurrentDiv(obj, i) {
      this.WaitPickList.forEach((item, index) => {
        this.$set(this.WaitPickList[index], "checked", false);
      });
      this.QuerySkustock(this.WaitPickList[i]);
      this.$set(this.WaitPickList[i], "checked", true);
      this.curTransportType = this.WaitPickList[i].transportType;
    },

    fill() {
      if (!this.selectRows.length) {
        this.$message({
          message: "请先勾选数据",
          type: "error",
        });
        return;
      }
      if (!this.outboundStatusAll) {
        this.$message({
          message: "请选择出库状态",
          type: "error",
        });
        return;
      }

      this.selectRows.forEach((item, i) => {
        this.tableData.forEach((item2, i2) => {
          if (item.stockingBoxListID === item2.stockingBoxListID) {
            this.$set(
              this.tableData[i2],
              "deliveryStatus",
              this.outboundStatusAll
            );
          }
        });
      });
    },

    submit() {
      if (this.curTransportType == "海运" || this.curTransportType == "空运") {
        if (!this.saveImgUrlArr.length) {
          this.$message({
            message: "请上传带*号的必填图片",
            type: "error",
          });
          return;
        }
      }

      let flag = false;
      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          let arr = [];
          this.saveImgUrlArr.forEach((item3, i) => {
            arr.push(item3.imageType);
          });
          if (item2.required && !arr.includes(item2.id)) {
            flag = true;
          }
        });
      });
      if (flag) {
        this.$message({
          message: "请上传带*号的必填图片",
          type: "error",
        });
        return;
      }

      let arr = [],
        loadCarInfoID = "";
        console.info(this.tableData);
      this.tableData.forEach((item, i) => {
        const {
          loadCarInfoID,
          stockingBoxListID,
          stockingBoxSumID,
          boxNo,
          deliveryStatus,
          stockingTaskID,
          logisticsBoxNo,
          nDestinationBoxNo,
          wmsBoxNo,
          tfDeliveryBoxInfoID
        } = item;
        arr.push({
          loadCarInfoID,
          stockingBoxListID,
          stockingBoxSumID,
          boxNo,
          deliveryStatus,
          stockingTaskID,
          logisticsBoxNo,
          nDestinationBoxNo,
          wmsBoxNo,
          tfDeliveryBoxInfoID
        });
      });

      this.WaitPickList.forEach((item, i) => {
        if (item.checked) loadCarInfoID = item.loadCarInfoID;
      });

      const data = {
        loadCarInfoID,
        submitType: 2,
        pcPutOnCarBoxList: arr,
        imageUrls: this.saveImgUrlArr,
      };

      const loading = this.$loading({
        lock: true,
        text: "操作中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      console.log("data", data);
      PutOnCarSubmit(data).then((res) => {
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });

          this.clearImgModel();
          this.close();
          this.initTable();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    clearImgModel() {
      this.imgObj = {
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      };

      this.saveImgUrlArr = [];
    },

    outboundSuccess() {
      let flag = false,
        num1 = 0,
        num2 = 0;
      if (!this.tableData.length) {
        this.$message({
          message: "请先选择一条数据！",
          type: "error",
        });
        return;
      }

      this.tableData.forEach((item, i) => {
        if (!item.deliveryStatus) {
          flag = true;
        }
        if (item.deliveryStatus === "1") {
          num1++;
        }
        if (item.deliveryStatus === "2") {
          num2++;
        }
      });

      if (flag) {
        this.$message({
          message: "存在未选择出库状态数据，请先选择！",
          type: "warning",
        });
        return;
      }

      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          this.$set(this.photoList[i][i2], "required", false);
          if (this.curTransportType == "空运" && [1, 7].includes(item2.id)) {
            this.$set(this.photoList[i][i2], "required", true);
          }
          if (
            this.curTransportType == "海运" &&
            [1, 2, 6, 7].includes(item2.id)
          ) {
            this.$set(this.photoList[i][i2], "required", true);
          }
        });
      });

      this.num1s = num1;
      this.num2s = num2;

      this.showPhotoModel = true;

      var loadCarInfoID = 0;
      this.WaitPickList.forEach((item, i) => {
        if (item.checked) loadCarInfoID = item.loadCarInfoID;
      });

      var that = this;
      const loading2 = that.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      that.IshowFinshPutCarBtn = false;
      GetPutOnCarLoadingReviewImageListType({
        loadCarInfoID: loadCarInfoID,
      }).then((res) => {
        var imageData = res.response;
        loading2.close();
        that.IshowFinshPutCarBtn = true;
        that.saveImgUrlArr = [];
        if (imageData != null) {
          imageData.forEach((item, i) => {
            that.saveImgUrlArr.push({
              imageUrl: item.fileUrl,
              imageType: item.imageType,
            });

            if (item.imageType == 1) {
              that.imgObj.img1 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 2) {
              that.imgObj.img2 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 3) {
              that.imgObj.img3 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 4) {
              that.imgObj.img4 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 5) {
              that.imgObj.img5 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 6) {
              that.imgObj.img6 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 7) {
              that.imgObj.img7 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 8) {
              that.imgObj.img8 = `data:image/png;base64,${item.imageData}`;
            }
            if (item.imageType == 9) {
              that.imgObj.img9 = `data:image/png;base64,${item.imageData}`;
            }
          });
        }
      });
    },

    imgMouseOver(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", true);
    },

    imgMouseLeave(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", false);
    },

    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        const m = type.split("")[3];
        if (m == item.imageType) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },

    showImg(base64Url) {
      this.dialogVisible = true;
      this.dialogImageUrl = base64Url;
    },

    changeImg(i, i2) {
      const img = document.getElementsByClassName("img")[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.toUpload(i, i2);
    },

    chooseImage(num) {
      console.log("num=", num);
      this.currentImg = num;
      document.getElementsByClassName("img")[0].value = "";
      document.getElementsByClassName("img")[0].click();
    },

    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(that.imgObj, `img${that.currentImg}`, e.target.result);
      };
      reader.readAsDataURL(file[0]);
    },

    toUpload(i, i2) {
      const that = this;
      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      const s = this.currentImg;
      this.$set(this.photoList[i][i2], "loading", true);

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        this.$set(this.photoList[i][i2], "loading", false);
        if (res.data.status === 200 && res.data.success) {
          console.log("this.currentImg=", this.currentImg);
          this.saveImgUrlArr.push({
            imageUrl: res.data.response[0].urlPath,
            imageType: s,
          });
          this.imgFiles = [];
        } else {
          this.$message({
            message: "图片上传失败，请重试",
            type: "error",
          });
        }
      });
    },

    close() {
      this.clearImgModel();
      this.showPhotoModel = false;
    },

    handleRowClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    handleRowSelect(rows) {
      this.selectRows = rows;
    },

    handleSearchChange(val, item) {
      const s = [",", ";", "'"];
      let m = s.filter((res) => {
        return val === res;
      });
      if (m.length || val.includes("'")) {
        val = "";
      }
      let v = splitStr(val);
      this.$set(this.filters, item, v);
    },

    addKeyCodeEvent() {
      const that = this;
      window.addEventListener("keyup", function (e) {
        if (e.keyCode === 13) that.initTable();
      });
    },
  },

  mounted() {
    //this.addKeyCodeEvent();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped lang="less">
.left-item {
  float: left;
  width: 20%;
  // min-width: 285px;
}
.left-item-card {
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}

.left-item-card {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(207, 210, 217);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgb(184, 182, 182);
  }
}
.image-box {
  float: left;
  width: 33.333%;
  text-align: center;
  margin-bottom: 15px;
  height: 150px;
}
.sign-photo-btn {
  width: 100px;
  border: 1px dashed #ccc;
  margin: 0 auto;
  height: 100px;
  cursor: pointer;
}
.sign-photo-btn:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.sign-photo-item:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.photo-s {
  color: #bfbfbf;
  padding: 23px 0;
  margin: 0;
  i {
    font-size: 55px;
  }
}
.sign-photo-item {
  height: 100px;
  width: 100px;
  margin: 0 auto;
  position: relative;
  img {
    height: 100px;
    width: 100px;
  }
}
.del-box {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    cursor: pointer;
    color: rgb(248, 248, 248);
    margin-top: 35px;
  }
}
.loading-box {
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    color: rgb(224, 222, 222);
    margin-top: 35px;
  }
}
.hidden {
  display: none;
}
</style>

<style>
.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>